import { AlertTriangle, Info, ShieldAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import styles from './ConfirmDialog.module.css';

export type ConfirmTone = 'danger' | 'warning' | 'info';

export type ConfirmDialogProps = {
  open: boolean;
  tone?: ConfirmTone;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const ICONS: Record<ConfirmTone, ReactNode> = {
  danger: <ShieldAlert size={20} />,
  warning: <AlertTriangle size={20} />,
  info: <Info size={20} />,
};

export function ConfirmDialog({
  open,
  tone = 'warning',
  title,
  description,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  isLoading,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      size="sm"
      showCloseButton={false}
      footer={
        <>
          <Button variant="ghost" onClick={onCancel} disabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button
            variant={tone === 'danger' ? 'danger' : 'primary'}
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className={styles.body}>
        <span className={`${styles['icon-wrap']} ${styles[`icon-${tone}`]}`}>{ICONS[tone]}</span>
        <div className={styles.content}>
          <h3 className={styles.title}>{title}</h3>
          {description ? <p className={styles.description}>{description}</p> : null}
        </div>
      </div>
    </Modal>
  );
}
